module.exports = __webpack_public_path__ + "img/whatsapp.08469986.png";